<template>
	<div class="form-group">
  		<fieldset :aria-describedby="name + '-ids-hint'">
			<legend>
				<p v-if="$slots.question" class="input__question">
					<slot name="question"></slot>
					<i class="fas fa-asterisk" v-if="required"></i>
				</p>
			</legend>
			<div class="small input__description" :id="name + '-ids-hint'">
				<slot name="description"></slot>
			</div>

    		<div
				class="input__controls"
				v-for="opt in options"
				v-bind:key="opt.value"	
			>				
				<div
					class="form-group form-check"
				>
					<input :id="opt.value" class="form-check-input" :aria-describedby="'opt-ids-' + name + '-hint'" :data-aria-controls="opt.hasTextarea ? name + '-other-conditional' : null" type="checkbox" :value="opt.value" :name="name" :checked="optionIsChecked(opt.value)" @change="onCheckboxChange($event)"/>
					<label :for="opt.value" class="form-check-label form-label">
						{{ opt.label }}
					</label>
					<div 
						v-if="opt.description"
						class="text-muted d-block input__description"
						:id="'opt-ids-' + name + '-hint'">
						<small>{{ opt.description }}</small>
					</div>
				</div>

				<div
					v-if="opt.hasTextarea &&
						opt.textareaName &&
						optionIsChecked(opt.value)"
					class="conditional"
					:id="name + '-other-conditional'"
				>
					<div class="form-group">
						<label :for="opt.value" class="form-check-label form-label">
							{{ opt.conditionalText }}
						</label>
						<input
							:id="opt.value"
							type="text"
							class="form-control"
							:name="opt.textareaName"
							:value="form[opt.textareaName]"
							@change="onTextChange(opt.textareaName, $event.target.value)"	
						/>
						<p
							class="form-error"
							v-if="form.errors.get(opt.textareaName)"
							v-text="form.errors.get(opt.textareaName)"
							role="alert"
							aria-live="assertive">
						</p>	
					</div>
				</div>
    		</div>
			<p class="form-error" v-if="error" v-text="error" role="alert" aria-live="assertive"></p>
  		</fieldset>
	</div>
</template>

<script>
export default {
	props: {
		error: String,
		name: String,
		value: Array,
		required: Boolean,
		options: Array,
		// Pass the whole form so we can access related textareas
		form: Object
	},
	methods: {
		optionIsChecked(opt) {
			return this.value && this.value.includes(opt);
		},
		onCheckboxChange($event) {
			var previouslySelected = this.value || [];
		  
			var newValue = [];
			if ($event.target.checked) {
				newValue = [...previouslySelected, $event.target.value];
			} else {
				newValue = previouslySelected.filter(
					(x) => x != $event.target.value
				);
			}
			if ($event.target.value === 'none' || $event.target.value === 'involved_none_above') {
				newValue = [$event.target.value];
			}
			
			this.$emit("input", newValue);
		},
		onTextChange(field, value) {
			this.$emit("textarea-updated", { field: field, value });
		},
	},
};
</script>